module.exports = __webpack_public_path__ + "static/media/centre-national-musique-logo.1ec1910a.png";